import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ReelsCreatorSubpageFrame } from './ReelsCreatorSubpageFrame';

/** The brand kits page's frame; the brand kit scrolls its own panes. */
export const ReelsCreatorBrandsFrame = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation('reelsCreator');
  return (
    <ReelsCreatorSubpageFrame
      title={t('reelsCreatorBrandsPage.title')}
      testId="reels-creator-brands"
    >
      {children}
    </ReelsCreatorSubpageFrame>
  );
};
